import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const FounderMessage = () => {
    return (
        <section className="relative w-full bg-white py-0 lg:py-0 overflow-hidden ">
            <div className='max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] lg:py-[80px] py-[40px]'>
                <motion.div
                    animate={{ x: [0, -20, 0], y: [0, 15, 0] }}
                    transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
                    className="absolute top-[-50px] right-[-100px] opacity-30 pointer-events-none"
                >
                    <svg width="600" height="500" viewBox="0 0 600 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M150 -50C250 150 400 -50 500 150C600 -50 750 150 850 -50" stroke="#CBD5E1" strokeWidth="1" />
                        <path d="M150 -30C250 170 400 -30 500 170C600 -30 750 170 850 -30" stroke="#CBD5E1" strokeWidth="1" />
                        <path d="M150 -10C250 190 400 -10 500 190C600 -10 750 190 850 -10" stroke="#CBD5E1" strokeWidth="1" />
                        <path d="M150 10C250 210 400 10 500 210C600 10 750 210 850 10" stroke="#CBD5E1" strokeWidth="1" />
                        <path d="M150 30C250 230 400 30 500 230C600 30 750 230 850 30" stroke="#CBD5E1" strokeWidth="1" />
                    </svg>
                </motion.div>
                <br />

                <div className="mx-auto relative z-10">
                    {/* <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">

                    <motion.h2
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        className="font-[600] font-sora text-[26px] md:text-[32px] leading-[34px] md:leading-[40px] text-[#01386A]"
                    >
                        Message from Our Founder
                    </motion.h2>
                    <Link to='/founders-message'>
                        <button className="bg-[#01386A] text-white py-2 px-5 rounded hover:bg-[#012a5a] transition-colors w-fit">
                            Read More
                        </button>
                    </Link>

                </div> */}
                    {/* <br />
                <br /> */}

                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        className="w-full bg-[#F0F0F0] p-[20px] md:p-[30px] lg:p-[50px] border-b-[7px] border-[#ED6800] relative"
                    >
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 md:gap-8 mb-[60px]">
                            <div className="w-[120px] h-[120px] md:w-[160px] md:h-[160px] flex-shrink-0 bg-black overflow-hidden shadow-lg">
                                <img
                                    src="/assets/sales/ajit yadav.jpeg"
                                    alt="Ajit Yadav"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="flex flex-col">
                                <h3 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora leading-tight mb-[10px]">
                                    Ajit Yadav
                                </h3>
                                <p className="text-[#49577A] text-[16px] md:text-[20px] font-[600] tracking-[-0.64px] font-sora">
                                    Founder & CEO, Mobikode
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col gap-6">
                            <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora">
                                Message from Our Founder
                            </h2>

                            <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] leading-[1.8] font-graphik">
                                At Mobikode, our journey began with a simple yet powerful belief: technology should not just support businesses, it should accelerate them.
                            </p>

                            <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] leading-[1.8] font-graphik">
                                When I founded Mobikode in 2017, the vision was clear: to build a technology partner that delivers not only solutions, but measurable impact. Over the years, we have evolved into a global engineering and consulting organization, working with enterprises across industries to solve complex challenges through innovation, agility, and deep domain expertise.
                            </p>

                            <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] leading-[1.8] font-graphik">
                                Today, as digital transformation continues to redefine industries, our focus remains stronger than ever: enabling businesses to harness the power of AI, data, and modern engineering to stay ahead of the curve. Whether it's building scalable platforms, modernizing legacy systems, or driving intelligent automation, our goal is to create solutions that are future-ready and business-aligned.
                            </p>

                            <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] leading-[1.8] font-graphik">
                                What sets Mobikode apart is our commitment to partnership. We don't just deliver projects; we collaborate, co-create, and grow alongside our clients. Our teams bring together technical excellence, design thinking, and a strong ownership mindset to ensure every engagement delivers tangible value.
                            </p>

                            <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] leading-[1.8] font-graphik">
                                As we continue to expand across geographies and capabilities, our mission remains unchanged: to empower organizations with technology that drives growth, efficiency, and innovation.
                            </p>

                            <p className="text-[#49577A] text-[14px] md:text-[16px] font-[500] leading-[1.8] font-graphik">
                                I sincerely thank our clients, partners, and our incredible team for being a part of this journey.
                            </p>

                            <h3 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mt-[24px]">
                                Let's build the future together.
                            </h3>

                            <p className="text-[#49577A] text-[16px] md:text-[20px] font-[500] font-graphik mt-1">
                                Warm regards, <br /> Ajit Yadav
                            </p>
                        </div>
                    </motion.div>
                </div>
            </div>

        </section>
    );
};

export default FounderMessage;
